import { apiSlice } from "../Slices/apiSlice";


export const CheckoutService = apiSlice.injectEndpoints({
    endpoints: builder => ({
      getAllDeliveryOptions: builder.query({
        query: () => "/delivery-management/managed-delivery" 
      }),
  
      //card details for checkout...............................................................
      getAllCardTypes: builder.query({
        query: () => "/ccType-management/managed-ccType" 
      }),
  
      getAllSavedCards: builder.query({
        query: () => "/paymentDetails-management/managed-paymentDetails/byUser",
        providesTags: ["cards"],
      }),
  
      // confirm order...........................................................................
      updateOrder: builder.mutation({
        query: (orderDetails) => ({
          url: '/orderHead-management/managed-orderHead',  
          method: 'PUT',
          body: orderDetails
        }),
        // Settling an order frees the table, so the table list (and the
        // activeOrderHeadId it reports) has to be refetched too.
        invalidatesTags: ['cart', 'table']
      }),
  
      deleteCard: builder.mutation({
        query: (id) => ({
          url: `/card-management/managed-card/${id}`,
          method: "DELETE",
        }),
        invalidatesTags: ["cards"]
      }),
  
      stripePay: builder.mutation({
          query: (details) => ({
              url: '/orderHead-management/managed-orderHead/charge',
              method: 'POST',
              body: details
          }),
          invalidatesTags: ["cart"]
      }),
  
    })
  });
  
  // Export hooks for usage in functional components  
  export const {
      useGetAllDeliveryOptionsQuery,
      useGetAllCardTypesQuery,
      useGetAllSavedCardsQuery,
      useUpdateOrderMutation,
      useDeleteCardMutation,
      useStripePayMutation,
  } = CheckoutService;